import { render, staticRenderFns } from "./tab_store_pi.vue?vue&type=template&id=97b372f2&scoped=true"
import script from "./tab_store_pi.vue?vue&type=script&lang=js"
export * from "./tab_store_pi.vue?vue&type=script&lang=js"
import style0 from "./tab_store_pi.vue?vue&type=style&index=0&id=97b372f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b372f2",
  null
  
)

export default component.exports